import LNB from '@/components/common/LNB';
import { BizTargetType } from '@/constants/bizTargetType';
import { BIZ_TYPE } from '@/constants/bizType';
import LNBAccountSearch from '@/outlets/ContainerOutlet/LNBLayout/LNBAccountSearch';
import { useAuthStore } from '@/store/auth';

const LNBAccount = () => {
  const { bizType, bizTargetType, dealerName } = useAuthStore();

  return (
    <LNB.Account>
      <LNBAccountSearch />
      <LNB.AccountInfo>
        {bizType && (
          <div className="ad_item">
            <strong className="tit_item">{BIZ_TYPE[bizType]}</strong>
          </div>
        )}
        <div className="ad_item">
          <strong className="tit_item">{bizTargetType === BizTargetType.DIRECT_PARTNER ? '직계약' : '딜러사'}</strong>
          {bizTargetType === BizTargetType.INDIRECT_PARTNER && <div className="txt_item">{dealerName}</div>}
        </div>
      </LNB.AccountInfo>
    </LNB.Account>
  );
};

export default LNBAccount;
